import {
	getSplitInitialStep,
	FlowConfig,
	getSplitFormGraph,
} from '@/helpers/split/splitFormFlow';
import { useEffect, useMemo, useState } from 'react';
import { useSplitAndHeap } from './useSplitAndHeap';
import { Beacon } from '@/components/forms/FormContext';

export const useSplitFormFlow = <
	StepMap extends string,
	State extends { splitConfig?: FlowConfig<StepMap>; activeStep: StepMap },
>(
	featureName: string,
	defaultGraph: Beacon<StepMap>,
	defaultState: State,
	steps: Record<string, StepMap>,
) => {
	const [isLoading, setIsLoading] = useState(true);
	const [formGraph, setFormGraph] = useState(defaultGraph);

	const { [featureName]: Flow, isReady } = useSplitAndHeap(featureName);

	const updatedState = useMemo(() => {
		if (Flow.treatment === 'on' && Flow.config) {
			const config = JSON.parse(Flow.config);
			const initialStep = getSplitInitialStep(config);
			const stateCopy = structuredClone(defaultState);
			stateCopy.splitConfig = config;
			stateCopy.activeStep = initialStep as StepMap;
			return stateCopy;
		}
		return defaultState;
	}, [Flow, defaultState]);

	useEffect(() => {
		if (isReady) {
			if (Flow.treatment !== 'off' && Flow.config) {
				const config = JSON.parse(Flow.config);
				const updatedGraph = getSplitFormGraph(config, steps);
				setFormGraph(updatedGraph);
			}
			setIsLoading(false);
		}
	}, [Flow, isReady, steps]);

	return { formGraph, isLoading, updatedState };
};
